import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { EstimateTypeService } from '@services/http/clients/estimate-type.service';
import { GenericDropdownComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-estimate-type-form-editor',
    templateUrl: './report-estimate-type-form-editor.component.html',
    styleUrls: ['./report-estimate-type-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportEstimateTypeFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class ReportEstimateTypeFormEditorComponent extends FormEditorBase<number | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Estimate Type');
    placeholderText = input<string>('Select Estimate Type');

    private readonly estimateTypeService = inject(EstimateTypeService);

    async ngOnInit(): Promise<void> {
        const estimateTypes = await this.estimateTypeService.getAwardableEstimateTypes();
        this.items.set(estimateTypes);
    }

    selectedItem(): any | undefined {
        const items = this.selectedItems();
        return items && items.length > 0 ? items[0] : undefined;
    }

    onSelectedItemChange(item?: any): void {
        if (item) this.onSelectedItemsChange([item]);
        else this.onSelectedItemsChange([]);
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number | null {
        const item = this.selectedItem();
        return item?.id ?? null;
    }

    protected override mapValueToSelectedItems(value: number | null): any[] {
        if (!value) return [];
        const items = this.items() ?? [];
        const found = items.find((item) => Number(item.id) === Number(value));
        return found ? [found] : [];
    }
}
